/* eslint-disable */
export function initMetaPixel() {
  if ((window as any).fbq) return

  var n: any
  n = (window as any).fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  }
  if (!(window as any)._fbq) (window as any)._fbq = n
  n.push = n
  n.loaded = !0
  n.version = '2.0'
  n.queue = []

  var t = document.createElement('script') as HTMLScriptElement
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(t)
  ;(window as any).fbq('init', '1682822106182558')
}

export function trackPageView() {
  if ((window as any).fbq) {
    ;(window as any).fbq('track', 'PageView')
  }
}

export function trackAddToCart() {
  if ((window as any).fbq) {
    ;(window as any).fbq('track', 'AddToCart', {
      content_name: 'Agente de Citas para Bienes Raíces',
      content_type: 'product',
      value: 6.39,
      currency: 'USD',
    })
  }
}
